import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'kubernetes',
  component: () => import('@/views/dashboard/iaas/kubernetes/root.vue'),
  children: [
    {
      meta: { feature: 'kubernetes' },
      path: '',
      name: 'kubernetes',
      component: () => import('@/views/dashboard/iaas/kubernetes/list.vue'),
    },
  ],
} satisfies RouteRecordRaw;
